import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { TabView, TabPanel } from "primereact/tabview";
import { Tooltip } from "react-tippy";
import styles from "./deliveries.module.scss";
import { FiEdit, FiPlay, FiMap } from "react-icons/fi";
import MakeDeliveryDialog from "./Dialogs/MakeDeliveryDialog";
import { Dialog } from "primereact/dialog";
import RouteFlowDialog from "./routeFlow/RouteFlowDialog";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { toast } from "react-toastify";
import ProgressBar from "./components/ProgressBar"; // Import the progress bar component
import useViewOnly from "../../hooks/useViewOnly";

function Deliveries() {
    const viewOnly = useViewOnly();
    const [deliveries, setDeliveries] = useState([]);
    const [filteredDeliveries, setFilteredDeliveries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [role, setRole] = useState("");
    const [currentUserId, setCurrentUserId] = useState(null);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [approvalRequests, setApprovalRequests] = useState([]);
    const [approvalLoading, setApprovalLoading] = useState(false);
    const [showDenyConfirm, setShowDenyConfirm] = useState(false);
    const [selectedDeliveryForDeny, setSelectedDeliveryForDeny] = useState(null);
    const [filters, setFilters] = useState({
        search: "",
        status: "",
        deliveryType: "",
        dateRange: null,
    });
    const [openDeliveryDialog, setOpenDeliveryDialog] = useState(false);
    const [openRoute, setOpenRoute] = useState(false);
    const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const isClerk = localStorage.getItem("role") === "clerk";

    console.log(deliveries);

    const token = localStorage.getItem("token");

    const statusOptions = [
        { label: "All Status", value: "" },
        { label: "Draft", value: "Draft" },
        { label: "In Transit", value: "In Transit" },
        { label: "Completed", value: "Completed" },
        { label: "Incomplete", value: "Incomplete" },
        { label: "Paused", value: "Paused" },
        { label: "Pending Approval", value: "Pending Approval" },
    ];

    const deliveryTypeOptions = [
        { label: "All Types", value: "" },
        { label: "Local Courier", value: "local courier" },
        { label: "Driver", value: "driver" },
        { label: "Lockbox", value: "lockbox" },
    ];

    // Helper functions
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString();
    };

    const calculateProgress = (delivery) => {
        if (!delivery.stops || delivery.stops.length === 0) return 0;
        const completedStops = delivery.stops.filter((stop) => stop.stopId.status === "Delivered").length;
        return Math.round((completedStops / delivery.stops.length) * 100);
    };

    const getCompletedStops = (delivery) => {
        if (!delivery.stops || delivery.stops.length === 0) return 0;
        return delivery.stops.filter((stop) => stop.stopId.status === "Delivered").length;
    };

    const groupDeliveriesByDate = (deliveries) => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());

        const startOfLastWeek = new Date(startOfWeek);
        startOfLastWeek.setDate(startOfWeek.getDate() - 7);

        const groups = {
            today: [],
            yesterday: [],
            thisWeek: [],
            lastWeek: [],
            earlier: [],
        };

        deliveries.forEach((delivery) => {
            const deliveryDate = new Date(delivery.createdAt || delivery.startDate);
            const deliveryDateOnly = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());
            const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const yesterdayDateOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

            if (deliveryDateOnly.getTime() === todayDateOnly.getTime()) {
                groups.today.push(delivery);
            } else if (deliveryDateOnly.getTime() === yesterdayDateOnly.getTime()) {
                groups.yesterday.push(delivery);
            } else if (deliveryDate >= startOfWeek) {
                groups.thisWeek.push(delivery);
            } else if (deliveryDate >= startOfLastWeek) {
                groups.lastWeek.push(delivery);
            } else {
                groups.earlier.push(delivery);
            }
        });

        return groups;
    };

    useEffect(() => {
        const userRole = localStorage.getItem("role");
        const userId = localStorage.getItem("userId");
        setRole(userRole);
        setCurrentUserId(userId);
        fetchDeliveries();
        if (userRole === "admin") {
            getApprovalRequests();
        }
    }, []);

    const fetchDeliveries = async () => {
        setLoading(true);
        try {
            const res = await handleGetRequest("/getAllDeliveries");
            setDeliveries(res?.data?.deliveries || []);
        } catch (error) {
            console.error("Error fetching deliveries:", error);
        } finally {
            setLoading(false);
        }
    };

    const getApprovalRequests = async () => {
        setApprovalLoading(true);
        try {
            const res = await handleGetRequest("/pending-approvals");
            setApprovalRequests(res?.data || []);
        } catch (error) {
            console.error("Error fetching approval requests:", error);
        } finally {
            setApprovalLoading(false);
        }
    };

    const handleApproveDelivery = async (deliveryId) => {
        try {
            const response = await dispatch(handlePostRequest({}, `/delivery/${deliveryId}/approve`, true, true));
            if (response !== "error") {
                toast.success("Delivery approved successfully");
                await getApprovalRequests();
                await fetchDeliveries();
            } else {
                toast.error("Error approving delivery");
            }
        } catch (error) {
            toast.error("Error approving delivery");
            console.error(error);
        }
    };

    const openDenyConfirm = (delivery) => {
        setSelectedDeliveryForDeny(delivery);
        setShowDenyConfirm(true);
    };

    const cancelDeny = () => {
        setShowDenyConfirm(false);
        setSelectedDeliveryForDeny(null);
    };

    const confirmDeny = () => {
        if (selectedDeliveryForDeny) {
            handleDenyDelivery(selectedDeliveryForDeny._id);
        }
    };

    const handleDenyDelivery = async (deliveryId) => {
        try {
            const response = await dispatch(handlePostRequest({}, `/delivery/deleteDelivery/${deliveryId}`, true, false));
            // handleDeleteRequest returns response?.data on success, error?.response on failure
            // Error responses contain a `status` property (400/500), success responses do not
            if (response && !response?.status) {
                toast.success("Delivery rejected and deleted successfully");
                await getApprovalRequests();
                await fetchDeliveries();
                setShowDenyConfirm(false);
                setSelectedDeliveryForDeny(null);
            } else {
                toast.error(response?.data?.message || "Error denying delivery");
            }
        } catch (error) {
            toast.error("Error denying delivery");
            console.error(error);
        }
    };

    useEffect(() => {
        if (!token) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("userId");
            localStorage.removeItem("user");
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        applyFilters();
    }, [filters, deliveries, activeTabIndex]);

    const APPROVAL_REQUESTS_TAB_INDEX = role === "admin" ? 2 : -1;

    const applyFilters = () => {
        let filtered = [...deliveries];

        // Tab filtering
        if (activeTabIndex === 0) {
            // Active tab - deliveries with stops + Pending Approval with 0 stops + Draft with isRequiredApproval=true
            filtered = filtered.filter(
                (delivery) =>
                    (delivery.stops && delivery.stops.length > 0) || // All deliveries with stops
                    delivery.status === "Pending Approval" || // Pending Approval (regardless of stops)
                    (delivery.status === "Draft" && delivery.isRequiredApproval === true), // Draft approved for route
            );
        } else if (activeTabIndex === APPROVAL_REQUESTS_TAB_INDEX) {
            // Approval Requests tab - uses separate approvalRequests state
            setFilteredDeliveries([]);
            return;
        } else {
            // No stops tab - deliveries with 0 stops AND (isRequiredApproval false or doesn't exist)
            filtered = filtered.filter((delivery) => (!delivery.stops || delivery.stops.length === 0) && (delivery.isRequiredApproval === false || delivery.isRequiredApproval === undefined));
        }

        // Search filter
        if (filters.search) {
            filtered = filtered.filter((delivery) => delivery.deliveryId?.toLowerCase().includes(filters.search.toLowerCase()) || delivery.driverName?.toLowerCase().includes(filters.search.toLowerCase()) || delivery.handlerName?.toLowerCase().includes(filters.search.toLowerCase()));
        }

        // Status filter
        if (filters.status) {
            filtered = filtered.filter((delivery) => delivery.status === filters.status);
        }

        // Delivery type filter
        if (filters.deliveryType) {
            filtered = filtered.filter((delivery) => delivery.deliveryType === filters.deliveryType);
        }

        // Date range filter
        if (filters.dateRange && filters.dateRange.length === 2) {
            const [startDate, endDate] = filters.dateRange;
            filtered = filtered.filter((delivery) => {
                const deliveryDate = new Date(delivery.createdAt || delivery.startDate);
                return deliveryDate >= startDate && deliveryDate <= endDate;
            });
        }

        setFilteredDeliveries(filtered);
    };

    const handleFilterChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const clearFilters = () => {
        setFilters({
            search: "",
            status: "",
            deliveryType: "",
            dateRange: null,
        });
    };

    const getActiveDeliveriesCount = () => {
        return deliveries.filter((delivery) => (delivery.stops && delivery.stops.length > 0) || delivery.status === "Pending Approval" || (delivery.status === "Draft" && delivery.isRequiredApproval === true)).length;
    };

    const getNoStopsDeliveriesCount = () => {
        return deliveries.filter((delivery) => (!delivery.stops || delivery.stops.length === 0) && (delivery.isRequiredApproval === false || delivery.isRequiredApproval === undefined)).length;
    };

    const getPendingApprovalCount = () => {
        return approvalRequests.length;
    };

    // ... (keep all your existing handler functions: handleAddDelivery, handleEditDelivery, etc.)

    const handleAddDelivery = () => {
        setOpenDeliveryDialog(true);
    };

    const handleEditDelivery = (deliveryId) => {
        history.push(`/deliveries/edit/${deliveryId}`);
    };

    const handleStartDelivery = async (delivery) => {
        if (!delivery.stops || delivery.stops.length === 0) {
            toast.error("Cannot start delivery with no stops. Please add stops first.");
            return;
        }

        if (role === "driver" && delivery.driverId !== currentUserId) {
            toast.error("You cannot start this delivery. You are not the assigned driver.");
            return;
        }

        const data = {
            deliveryId: delivery._id,
            status: "In Transit",
            startTime: new Date().toISOString(),
        };

        const res = await dispatch(handlePostRequest(data, "/startDelivery", true, true));
        if (res !== "error") {
            toast.success("Delivery started successfully");
            history.push(`/delivery/${delivery._id}/tracking`);
            fetchDeliveries();
        } else {
            toast.error("Failed to start delivery");
        }
    };

    const handleShowRoute = (deliveryId) => {
        history.push(`/delivery/${deliveryId}/tracking`);
    };

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "Draft":
                return styles.statusDraft;
            case "In Transit":
                return styles.statusInTransit;
            case "Completed":
                return styles.statusCompleted;
            case "Incomplete":
                return styles.statusIncomplete;
            case "Paused":
                return styles.statusPaused;
            case "Pending Approval":
                return styles.statusPendingApproval;
            default:
                return "";
        }
    };

    const handleSuccess = (deliveryId, deliveryStatus) => {
        setOpenDeliveryDialog(false);
        fetchDeliveries();
        if (deliveryStatus === "Pending Approval") {
            toast.info("Delivery is pending admin approval. You can create a route once it's approved.");
            if (role === "admin") {
                getApprovalRequests();
            }
        } else {
            setSelectedDeliveryId(deliveryId);
            setOpenRoute(true);
        }
    };

    const canStartDelivery = (delivery) => {
        return delivery?.driverId?._id === currentUserId;
    };

    const getStartButtonTooltip = (delivery) => {
        if (!delivery.stops || delivery.stops.length === 0) {
            return "No stops added - Cannot start delivery";
        }
        if (role === "admin" || role === "handler") {
            return "Start Delivery";
        }
        if (role === "driver") {
            if (delivery.driverId === currentUserId) {
                return "Start Delivery";
            } else {
                return "You cannot start this delivery (not assigned to you)";
            }
        }
        return "Start Delivery";
    };

    const hasNoStops = (delivery) => {
        return !delivery.stops || delivery.stops.length === 0;
    };

    const renderDeliveryCard = (delivery) => {
        const isDisabled = hasNoStops(delivery);
        const isPendingApproval = delivery.status === "Pending Approval";
        const isApprovedDraft = delivery.status === "Draft" && delivery.isRequiredApproval === true;
        const progress = calculateProgress(delivery);
        const completedStops = getCompletedStops(delivery);
        const totalStops = delivery.stops ? delivery.stops.length : 0;
        const isAssignedDriver = role === "driver" && delivery.driverId === currentUserId;
        const isAssignedHandler = role === "handler" && delivery.handlerId === currentUserId;

        return (
            <div key={delivery._id} className={`${styles.deliveryCard} ${isPendingApproval ? styles.disabledCard : ""}`}>
                {isPendingApproval && (
                    <div className={styles.pendingApprovalBanner}>
                        <i className="pi pi-clock"></i>
                        <span>This delivery is pending admin approval. You can create a route once it's approved.</span>
                    </div>
                )}

                {isApprovedDraft && isDisabled && (
                    <div className={styles.noStopsBanner}>
                        <i className="pi pi-exclamation-triangle"></i>
                        <span>No route added - Please add route to activate</span>
                    </div>
                )}

                <div className={styles.cardHeader}>
                    <div className={styles.deliveryId}>
                        <i className="pi pi-hashtag"></i>
                        <span>{delivery.deliveryId}</span>
                    </div>
                    <span className={`${styles.statusBadge} ${getStatusBadgeClass(delivery.status)}`}>{delivery.status}</span>
                </div>

                <div className={styles.cardBody}>
                    <div className={styles.infoRow}>
                        <i className="pi pi-user"></i>
                        <div>
                            <label>Driver</label>
                            <span>
                                {delivery.driverName || "N/A"}
                                {role === "driver" && delivery.driverId === currentUserId && <span className={styles.youBadge}> (You)</span>}
                            </span>
                        </div>
                    </div>

                    <div className={styles.infoRow}>
                        <i className="pi pi-id-card"></i>
                        <div>
                            <label>Handler</label>
                            <span>
                                {delivery.handlerName || "N/A"}
                                {role === "handler" && delivery.handlerId === currentUserId && <span className={styles.youBadge}> (You)</span>}
                            </span>
                        </div>
                    </div>

                    <div className={styles.infoRow}>
                        <i className="pi pi-calendar"></i>
                        <div>
                            <label>Start Date</label>
                            <span>{formatDate(delivery.startDate || delivery.createdAt)}</span>
                        </div>
                    </div>

                    {progress === 100 && delivery.status === "Completed" && (
                        <div className={styles.infoRow}>
                            <i className="pi pi-check-circle"></i>
                            <div>
                                <label>Completion Date</label>
                                <span>{formatDate(delivery.endTime)}</span>
                            </div>
                        </div>
                    )}

                    <div className={styles.infoRow}>
                        <i className="pi pi-map-marker"></i>
                        <div>
                            <label>Progress</label>
                            <span className={isPendingApproval || (isApprovedDraft && isDisabled) ? styles.noStopsText : ""}>
                                {totalStops > 0 ? `${completedStops} of ${totalStops} stops completed` : "0 stops"}
                                {(isPendingApproval || (isApprovedDraft && isDisabled)) && " ⚠️"}
                            </span>
                            {totalStops > 0 && <ProgressBar percentage={progress} status={delivery.status} />}
                        </div>
                    </div>
                </div>

                <div className={styles.cardFooter}>
                    {/* Add Route Button - For approved draft deliveries with no stops - Only for assigned driver or handler */}
                    {!isClerk && isApprovedDraft && isDisabled && (
                        <Tooltip title="Add Route" position="top" arrow={true}>
                            <button
                                className={`${styles.actionButton} ${styles.addRouteButton}`}
                                onClick={() => {
                                    setSelectedDeliveryId(delivery._id);
                                    setOpenRoute(true);
                                }}
                            >
                                <FiMap />
                                <span>Add Route</span>
                            </button>
                        </Tooltip>
                    )}

                    {/* Start Button - For draft deliveries (both approved and non-approved with stops) */}
                    {!isClerk && !isPendingApproval && delivery?.status === "Draft" && canStartDelivery(delivery) && (
                        <Tooltip title={getStartButtonTooltip(delivery)} position="top" arrow={true}>
                            <button className={`${styles.actionButton} ${styles.startButton} ${isDisabled || viewOnly ? styles.disabledButton : ""}`} onClick={() => !isDisabled && !viewOnly && handleStartDelivery(delivery)}>
                                <FiPlay />
                                <span>Start</span>
                            </button>
                        </Tooltip>
                    )}

                    {/* {!isPendingApproval && delivery?.status === "Draft" && role === "driver" && !canStartDelivery(delivery) && (
                        <Tooltip title={getStartButtonTooltip(delivery)} position="top" arrow={true}>
                            <button className={`${styles.actionButton} ${styles.startButton} ${styles.disabledButton}`} disabled>
                                <FiPlay />
                                <span>Start</span>
                            </button>
                        </Tooltip>
                    )} */}

                    {!isClerk && (delivery?.status === "In Transit" || delivery?.status === "Paused") && canStartDelivery(delivery) && (
                        <Tooltip title="Show Route" position="top" arrow={true}>
                            <button className={`${styles.actionButton} ${styles.routeButton}`} onClick={() => handleShowRoute(delivery._id)}>
                                <FiMap />
                                <span>Route</span>
                            </button>
                        </Tooltip>
                    )}

                    {(role === "admin" || role === "handler" || role === "clerk") && delivery?.status !== "Draft" && (
                        <Tooltip title="View Details" position="top" arrow={true}>
                            <button className={`${styles.actionButton} ${styles.detailsButton}`} onClick={() => history.push(`/delivery/${delivery._id}/details`)}>
                                <i className="pi pi-info-circle" />
                                <span>Details</span>
                            </button>
                        </Tooltip>
                    )}

                    {role === "admin" && (delivery?.status === "In Transit" || delivery?.status === "Paused") && (
                        <Tooltip title="Live Tracking" position="top" arrow={true}>
                            <button className={`${styles.actionButton} ${styles.trackingButton}`} onClick={() => history.push(`/delivery/${delivery._id}/live-tracking`)}>
                                <i className="pi pi-map-marker" />
                                <span>Track</span>
                            </button>
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    };

    const renderDateGroup = (groupName, deliveries, label) => {
        if (deliveries.length === 0) return null;

        return (
            <div key={groupName} className={styles.dateGroup}>
                <div className={styles.dateGroupHeader}>
                    <h3>{label}</h3>
                    <span className={styles.groupCount}>{deliveries.length} deliveries</span>
                </div>
                <div className={styles.deliveriesGrid}>{deliveries.map(renderDeliveryCard)}</div>
            </div>
        );
    };

    const groupedDeliveries = groupDeliveriesByDate(filteredDeliveries);

    return (
        <div className={styles.deliveriesPage}>
            <div className={styles.pageHeader}>
                <div>
                    <h2>Deliveries</h2>
                    <p>Manage and track all deliveries</p>
                </div>
                {(role === "handler" || role === "admin" || role === "driver") && (
                    <Tooltip title="Add new delivery" position="bottom" trigger="mouseenter" arrow={true}>
                        <Button
                            label="Add Delivery"
                            icon="pi pi-plus"
                            className={styles.addButton}
                            disabled={viewOnly}
                            tooltip={viewOnly ? "Clock in to add a delivery" : undefined}
                            onClick={handleAddDelivery}
                        />
                    </Tooltip>
                )}
            </div>

            <div className={styles.filtersSection}>
                <div className={styles.filterGroup}>
                    <label htmlFor="search">Search</label>
                    <InputText id="search" placeholder="Search by ID, driver, or handler..." value={filters.search} onChange={(e) => handleFilterChange("search", e.target.value)} className={styles.filterInput} />
                </div>

                <div className={styles.filterGroup}>
                    <label htmlFor="status">Status</label>
                    <Dropdown id="status" value={filters.status} options={statusOptions} onChange={(e) => handleFilterChange("status", e.value)} placeholder="Select Status" className={styles.dropdown} />
                </div>

                <div className={styles.filterGroup}>
                    <label htmlFor="deliveryType">Delivery Type</label>
                    <Dropdown id="deliveryType" value={filters.deliveryType} options={deliveryTypeOptions} onChange={(e) => handleFilterChange("deliveryType", e.value)} placeholder="Select Type" className={styles.dropdown} />
                </div>

                <div className={styles.filterGroup}>
                    <label htmlFor="dateRange">Date Range</label>
                    <Calendar id="dateRange" value={filters.dateRange} onChange={(e) => handleFilterChange("dateRange", e.value)} selectionMode="range" readOnlyInput placeholder="Select date range" className={styles.calendar} />
                </div>

                <div className={styles.filterGroup}>
                    <Button label="Clear Filters" icon="pi pi-filter-slash" className={styles.clearButton} onClick={clearFilters} />
                </div>
            </div>

            <div className={styles.tabsContainer}>
                <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)} className={styles.customTabs}>
                    <TabPanel header={`Active (${getActiveDeliveriesCount()})`} leftIcon="pi pi-check-circle">
                        <div className={styles.tabContent}>
                            {loading ? (
                                <div className={styles.loadingContainer}>
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
                                    <p>Loading deliveries...</p>
                                </div>
                            ) : filteredDeliveries.length === 0 ? (
                                <div className={styles.emptyState}>
                                    <i className="pi pi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                    <p>No active deliveries found</p>
                                </div>
                            ) : (
                                <>
                                    {renderDateGroup("today", groupedDeliveries.today, "Today")}
                                    {renderDateGroup("yesterday", groupedDeliveries.yesterday, "Yesterday")}
                                    {renderDateGroup("thisWeek", groupedDeliveries.thisWeek, "This Week")}
                                    {renderDateGroup("lastWeek", groupedDeliveries.lastWeek, "Last Week")}
                                    {renderDateGroup("earlier", groupedDeliveries.earlier, "Earlier")}
                                </>
                            )}
                        </div>
                    </TabPanel>

                    <TabPanel header={`No Stops (${getNoStopsDeliveriesCount()})`} leftIcon="pi pi-exclamation-triangle">
                        <div className={styles.tabContent}>
                            {loading ? (
                                <div className={styles.loadingContainer}>
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
                                    <p>Loading deliveries...</p>
                                </div>
                            ) : filteredDeliveries.length === 0 ? (
                                <div className={styles.emptyState}>
                                    <i className="pi pi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                    <p>No deliveries without stops found</p>
                                </div>
                            ) : (
                                <>
                                    {renderDateGroup("today", groupedDeliveries.today, "Today")}
                                    {renderDateGroup("yesterday", groupedDeliveries.yesterday, "Yesterday")}
                                    {renderDateGroup("thisWeek", groupedDeliveries.thisWeek, "This Week")}
                                    {renderDateGroup("lastWeek", groupedDeliveries.lastWeek, "Last Week")}
                                    {renderDateGroup("earlier", groupedDeliveries.earlier, "Earlier")}
                                </>
                            )}
                        </div>
                    </TabPanel>

                    {role === "admin" && (
                        <TabPanel header={`Approval Requests (${getPendingApprovalCount()})`} leftIcon="pi pi-check-square">
                            <div className={styles.tabContent}>
                                {approvalLoading ? (
                                    <div className={styles.loadingContainer}>
                                        <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
                                        <p>Loading approval requests...</p>
                                    </div>
                                ) : approvalRequests.length === 0 ? (
                                    <div className={styles.emptyState}>
                                        <i className="pi pi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                        <p>No pending approval requests</p>
                                    </div>
                                ) : (
                                    <div className={styles.approvalRequestsContainer}>
                                        <div className={styles.approvalRequestsTable}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Delivery ID</th>
                                                        <th>Driver Name</th>
                                                        <th>Created Date</th>
                                                        <th>Stops</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {approvalRequests.map((delivery) => (
                                                        <tr key={delivery._id}>
                                                            <td>{delivery.deliveryId || "N/A"}</td>
                                                            <td>{delivery.driverId?.firstName && delivery.driverId?.lastName ? `${delivery.driverId.firstName} ${delivery.driverId.lastName}` : delivery.driverName || "N/A"}</td>
                                                            <td>{formatDate(delivery.createdAt)}</td>
                                                            <td>{delivery.stops && delivery.stops.length > 0 ? `${delivery.stops.length} stop(s)` : "No stops"}</td>
                                                            <td className={styles.actionCell}>
                                                                <button className={styles.approveBtn} disabled={viewOnly} onClick={() => handleApproveDelivery(delivery._id)}>
                                                                    <i className="pi pi-check" />
                                                                    <span>Approve</span>
                                                                </button>
                                                                <button className={styles.denyBtn} disabled={viewOnly} onClick={() => openDenyConfirm(delivery)}>
                                                                    <i className="pi pi-times" />
                                                                    <span>Deny</span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className={styles.approvalCardsList}>
                                            {approvalRequests.map((delivery) => (
                                                <div key={delivery._id} className={styles.approvalCard}>
                                                    <div className={styles.approvalCardHeader}>
                                                        <span className={styles.approvalCardId}>
                                                            <i className="pi pi-hashtag"></i> {delivery.deliveryId || "N/A"}
                                                        </span>
                                                        <span className={`${styles.statusBadge} ${styles.statusPendingApproval}`}>Pending Approval</span>
                                                    </div>
                                                    <div className={styles.approvalCardBody}>
                                                        <div className={styles.approvalCardRow}>
                                                            <i className="pi pi-user"></i>
                                                            <div>
                                                                <label>Driver</label>
                                                                <span>{delivery.driverId?.firstName && delivery.driverId?.lastName ? `${delivery.driverId.firstName} ${delivery.driverId.lastName}` : delivery.driverName || "N/A"}</span>
                                                            </div>
                                                        </div>
                                                        <div className={styles.approvalCardRow}>
                                                            <i className="pi pi-calendar"></i>
                                                            <div>
                                                                <label>Created</label>
                                                                <span>{formatDate(delivery.createdAt)}</span>
                                                            </div>
                                                        </div>
                                                        <div className={styles.approvalCardRow}>
                                                            <i className="pi pi-map-marker"></i>
                                                            <div>
                                                                <label>Stops</label>
                                                                <span>{delivery.stops && delivery.stops.length > 0 ? `${delivery.stops.length} stop(s)` : "No stops"}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.approvalCardActions}>
                                                        <button className={styles.approveBtn} onClick={() => handleApproveDelivery(delivery._id)}>
                                                            <i className="pi pi-check" />
                                                            <span>Approve</span>
                                                        </button>
                                                        <button className={styles.denyBtn} onClick={() => openDenyConfirm(delivery)}>
                                                            <i className="pi pi-times" />
                                                            <span>Deny</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </TabPanel>
                    )}
                </TabView>
            </div>

            {!loading && filteredDeliveries.length > 0 && <div className={styles.resultsCount}>Showing {filteredDeliveries.length} deliveries</div>}

            <Dialog header="Create New Delivery" visible={openDeliveryDialog} style={{ width: "500px" }} onHide={() => setOpenDeliveryDialog(false)} breakpoints={{ "960px": "90vw", "640px": "100vw" }}>
                <MakeDeliveryDialog onClose={() => setOpenDeliveryDialog(false)} onSuccess={handleSuccess} />
            </Dialog>

            <Dialog header="Reject Delivery" visible={showDenyConfirm} style={{ width: "450px" }} onHide={cancelDeny} breakpoints={{ "960px": "90vw", "640px": "100vw" }}>
                <div className={styles.denyConfirmContent}>
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: "2.5rem", color: "#e74c3c" }}></i>
                    <p>Are you sure you want to reject this delivery? This action will permanently delete the delivery.</p>
                    {selectedDeliveryForDeny && (
                        <p className={styles.denyDeliveryId}>
                            Delivery ID: <strong>{selectedDeliveryForDeny.deliveryId || selectedDeliveryForDeny._id}</strong>
                        </p>
                    )}
                    <div className={styles.denyConfirmActions}>
                        <button className={styles.cancelBtn} onClick={cancelDeny}>
                            Cancel
                        </button>
                        <button className={styles.confirmDenyBtn} onClick={confirmDeny}>
                            Yes, Reject
                        </button>
                    </div>
                </div>
            </Dialog>

            <RouteFlowDialog
                visible={openRoute}
                onHide={() => {
                    setOpenRoute(false);
                    window.location.reload();
                }}
                deliveryId={selectedDeliveryId}
            />
        </div>
    );
}

export default Deliveries;
